import { render, staticRenderFns } from "./DynamicComponent.vue?vue&type=template&id=67867c8f&scoped=true&"
import script from "./DynamicComponent.vue?vue&type=script&lang=js&"
export * from "./DynamicComponent.vue?vue&type=script&lang=js&"
import style0 from "./DynamicComponent.vue?vue&type=style&index=0&id=67867c8f&prod&lang=scss&scoped=true&"
import style1 from "./DynamicComponent.vue?vue&type=style&index=1&id=67867c8f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67867c8f",
  null
  
)

export default component.exports